import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as yup from "yup";
import Select, { StylesConfig } from "react-select";
import { mapMstToOptions } from "utils/HelperFunction";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { VER } from "constants/server/api";
import { LOGO_URL, SERVER_NAME } from "constants/server/config";
import { env } from "env";
import CheckIcon from "@mui/icons-material/Check";
import { clearForgetPass, forgetPass } from "../../redux/handlers/auth/forgetPass.handler";
export function ForgetPassword() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), formdisabled = _useState[0], setFormdisabled = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState1[0], setModalsuccess = _useState1[1];
    var forgetPassReducer = useAppSelector(function(state) {
        return state.forgetPassReducer;
    });
    var getAllMstPrefixReducer = useAppSelector(function(state) {
        return state.getAllMstPrefixReducer;
    });
    var _useState2 = _sliced_to_array(useState([]), 2), optionsMstPrefix = _useState2[0], setOptionsMstPrefix = _useState2[1];
    useEffect(function() {
        localStorage.clear();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstPrefixReducer.isFetching);
        if (getAllMstPrefixReducer.data) {
            var options = mapMstToOptions(getAllMstPrefixReducer.data.data);
            setOptionsMstPrefix(_to_consumable_array(options));
        }
    }, [
        getAllMstPrefixReducer
    ]);
    var schema = yup.object().shape({
        mailsend: yup.string().email("กรุณากรอกอีเมลให้ถูกต้อง").required("กรุณากรอกอีเมล")
    });
    var _useState3 = _sliced_to_array(useState({
        token: btoa(JSON.stringify({
            timestamp: Date.now(),
            random: Math.random()
        })),
        mailsend: ""
    }), 2), formData = _useState3[0], setFormData = _useState3[1];
    var handleForgetPass = function(values) {
        dispatch(forgetPass(values, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        setIsLoading(forgetPassReducer.isFetching);
        if (forgetPassReducer.data && forgetPassReducer.isError) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "เกิดข้อผิดพลาด",
                navigateDirection: undefined,
                title: forgetPassReducer.data.message
            }));
            return;
        }
        if (forgetPassReducer.data && !forgetPassReducer.isError) {
            localStorage.setItem("forgetpassToken", formData.token);
            localStorage.setItem("forgetpassEmail", formData.mailsend);
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "กรุณาตรวจสอบอีเมลของคุณ",
                    direction: "/forgetpass/sendmail"
                });
            });
            setFormdisabled(true);
            dispatch(clearForgetPass());
        }
    }, [
        forgetPassReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "loginpage bg-white",
        children: [
            /*#__PURE__*/ _jsx(Row, {
                className: "g-0",
                children: /*#__PURE__*/ _jsx(Col, {
                    className: "d-flex justify-content-center align-items-center h-100vh",
                    children: /*#__PURE__*/ _jsx(Card, {
                        className: "box-login",
                        style: {
                            maxWidth: "600px"
                        },
                        children: /*#__PURE__*/ _jsx(Formik, {
                            initialValues: formData,
                            validationSchema: schema,
                            onSubmit: handleForgetPass,
                            children: function(param) {
                                var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, isValid = param.isValid, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue;
                                return /*#__PURE__*/ _jsxs(Form, {
                                    noValidate: true,
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "card card-st-2",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "card-body p-4",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-20 fw-500 tc-1",
                                                        children: "ลืมรหัสผ่าน"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16 fw-500 tc-6",
                                                        children: "โปรดป่อนอีเมลของคุณเพื่อให้ระบบจัดส่งลิงค์สำหรับการตั้งรหัสผ่านใหม่"
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                className: "mb-1",
                                                                children: [
                                                                    "อีเมล ",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        style: {
                                                                            color: "red"
                                                                        },
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "mailsend",
                                                                value: values.mailsend,
                                                                placeholder: "กรอกอีเมล",
                                                                onChange: function(e) {
                                                                    handleChange(e); // Update Formik's state
                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                        mailsend: e.target.value
                                                                    })); // Update formData state
                                                                },
                                                                isValid: touched.mailsend && !errors.mailsend,
                                                                isInvalid: !!errors.mailsend,
                                                                className: "form-st-1",
                                                                disabled: false
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs(Col, {
                                            className: "d-flex justify-content-center align-items-center mt-4",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    onClick: function() {
                                                        return navigate("/login");
                                                    },
                                                    className: "btn-return w-40 mr-2",
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "btn-login w-40",
                                                    disabled: forgetPassReducer.isFetching,
                                                    children: "ยืนยัน"
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            })
        ]
    });
}
